import Wrapper from "./Wrapper";
import { useFormContext } from './Provider';
import Actions from "./Actions";
import Conditional from "./Conditional";
// Files
import Address from "./Fields/Address";
import AllowedTimes from "./Fields/AllowedTimes";
import Assets from "./Fields/Assets";
import Checkboxes from "./Fields/Checkboxes";
import DateTime from "./Fields/DateTime";
import Duration from "./Fields/Duration";
import EventTriggers from "./Fields/EventTriggers";
import Frequency from "./Fields/Frequency";
import Hidden from "./Fields/Hidden";
import Money from "./Fields/Money";
import OptionalTime from "./Fields/OptionalTime";
import Password from "./Fields/Password";
import Radio from "./Fields/Radio";
import Repeatable from "./Fields/Repeatable";
import Round from "./Fields/Round";
import Section from "./Fields/Section";
import Select from "./Fields/Select";
import Services from "./Fields/Services";
import Settings from "./Fields/Settings";
import Switch from "./Fields/Switch";
import SwitchGroup from "./Fields/SwitchGroup";
import TextArea from "./Fields/TextArea";
import TextField from "./Fields/TextField";
import TimeRange from "./Fields/TimeRange";
import ULID from "./Fields/ULID";
import User from "./Fields/User";
import WorkingHours from "./Fields/WorkingHours";
import Wysiwyg from "./Fields/Wysiwyg";
// Validators
import AddressValidator from "./Validators/Address";
import EmailAddressValidator from "./Validators/EmailAddress";
import NumberValidator from "./Validators/Number";
import MoneyValidator from "./Validators/Money";
import OptionalTimeValidator from "./Validators/OptionalTime";
import PasswordValidator from "./Validators/Password";
import PhoneNumberValidator from "./Validators/PhoneNumber";
import RegexValidator from "./Validators/Regex";
import RequiredValidator from "./Validators/Required";
import ScheduleConstraints from "./Fields/ScheduleConstraints";
import URLValidator from "./Validators/URL";
import { ulid } from "ulid";

const Form = Wrapper;
export default Form;

const parseSettingsToData = (settings, filter) => {
    if (settings === null) {
        return null;
    }

    return settings.reduce((data, setting) => {
        if (filter && filter.includes(setting.key) === false) {
            return data;
        }

        if (setting.key === 'Quotes:FrequencyChoices') {
            data[setting.key] = setting.value.map(option => ({
                frequency: option,
                _id: ulid(),
            }));
            return data;
        }

        data[setting.key] = setting.html ?? setting.value;
        return data;
    }, {});
}

export {
    Form,
    useFormContext,
    Actions,
    Conditional,
    parseSettingsToData,
    // Files
    Address,
    AllowedTimes,
    Assets,
    Checkboxes,
    DateTime,
    Duration,
    EventTriggers,
    Frequency,
    Hidden,
    Money,
    OptionalTime,
    Password,
    Radio,
    Repeatable,
    Round,
    Section,
    Select,
    Services,
    Settings,
    Switch,
    SwitchGroup,
    TextArea,
    TextField,
    TimeRange,
    ULID,
    User,
    WorkingHours,
    Wysiwyg,
    // Validators
    AddressValidator,
    EmailAddressValidator,
    NumberValidator,
    MoneyValidator,
    OptionalTimeValidator,
    PasswordValidator,
    PhoneNumberValidator,
    RegexValidator,
    RequiredValidator,
    ScheduleConstraints,
    URLValidator,
}
